import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledBoxShare, StyledClose, StyledMsg } from './style';
import { Close } from '../../../../assets/images/index';

/* Core */
import ShareSend from './ShareSend';

/* Utils */
import { sendEmail } from '../../../utils/apiSocial';

class WrapperShareSend extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: false,
      isSend: false
    };
  }

  onSendHandler = (emailList, msg) => {
    const { baseContentId, contentType, onClose } = this.props;
    const data = {
      contentId: baseContentId,
      emailToSend: emailList,
      contentType,
      recommendationText: msg
    };

    this.setState({ isLoading: true });
    sendEmail(data)
      .then(() => {
        this.setState({ isSend: true });
        setTimeout(() => {
          this.setState({ isSend: false });
          onClose();
        }, 2000);
      })
      .catch(() => {
        this.setState({
          error: true
        });
      })
      .finally(() => this.setState({ isLoading: false }));
  };

  render() {
    const { className, activeShare, onClose } = this.props;
    const { isLoading, error, isSend } = this.state;

    return (
      <StyledBoxShare className={className} activeShare={activeShare}>
        <StyledClose
          svg={Close}
          size="s"
          hover
          color="light"
          onClick={onClose}
        />
        {!isSend ? (
          <ShareSend
            onSend={this.onSendHandler}
            isLoading={isLoading}
            error={error}
          />
        ) : (
          <StyledMsg>Mensaje enviado!</StyledMsg>
        )}
      </StyledBoxShare>
    );
  }
}

WrapperShareSend.propTypes = {
  className: PropTypes.string,
  activeShare: PropTypes.bool,
  onClose: PropTypes.func,
  baseContentId: PropTypes.string,
  contentType: PropTypes.string
};

WrapperShareSend.defaultProps = {
  activeShare: false
};

export default WrapperShareSend;
